import loadable from '@loadable/component';
import { advancedListingSchema } from './AdvancedListingSchema';
import { advancedCarouselSchema } from './AdvancedCarouselSchema';
import { YearAccordionSchema } from './YearAccordionSchema';
import { DownloadListingSchema } from './DownloadListingSchema';

// Dynamically import components using loadable
const LazyAdvancedListingBlockTemplate = loadable(() =>
  import('./AdvancedListingBlockTemplate'),
);
const LazyAdvancedCarouselBlockTemplate = loadable(() =>
  import('./AdvancedCarouselBlockTemplate'),
);
const LazyYearAccordionListingBlockTemplate = loadable(() =>
  import('./YearAccordionListingBlockTemplate'),
);
const LazyDownloadListingBlockTemplate = loadable(() =>
  import('./DownloadListingBlockTemplate'),
);

const applyConfig = (config) => {
  config.blocks.blocksConfig.listing.variations = [
    {
      id: 'advanced',
      title: 'Advanced Listing',
      template: LazyAdvancedListingBlockTemplate,
      schemaEnhancer: advancedListingSchema,
    },
    {
      id: 'advancedCarousel',
      title: 'Advanced Carousel',
      template: LazyAdvancedCarouselBlockTemplate,
      schemaEnhancer: advancedCarouselSchema,
    },
    {
      id: 'yearAccordionByTags',
      title: 'Year accordion by tags',
      template: LazyYearAccordionListingBlockTemplate,
      schemaEnhancer: YearAccordionSchema,
    },
    {
      id: 'downloadListing',
      title: 'Download Listing',
      template: LazyDownloadListingBlockTemplate,
      schemaEnhancer: DownloadListingSchema,
    },
    ...config.blocks.blocksConfig.listing.variations,
  ];
  return config;
};

export default applyConfig;